import { render } from "./category-popup.vue?vue&type=template&id=60afb4a7"
import script from "./category-popup.vue?vue&type=script&lang=js"
export * from "./category-popup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__